import React, { useEffect } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { Link } from "react-router-dom";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { getCurrentUser } from "../../Api/auth";
import { getremotefittingdatabyfitter } from "../../Api/iron";

function Fitting() {


    // const [userdata, setUserdata] = React.useState(null);
    // const [user_id, setUser_id] = React.useState(0);
    // const [remotefitting, setRemotefitting] = React.useState({});
    // console.log("remotefitting", remotefitting);


    // useEffect(() => {
    //     // setUserdata(getCurrentUser());
    //     const fetchUserData = async () => {
    //         try {
    //             const userData = await getCurrentUser();
    //             if (userData) {
    //                 setUserdata(userData);
    //                 setUser_id(userData.user._id);
    //             } else {
    //                 // Handle case where user data is missing or incomplete
    //                 console.error('User data is missing or incomplete.');
    //             }
    //         } catch (error) {
    //             // Handle any errors that occur during data fetching
    //             console.error('Error fetching user data:', error);
    //         }
    //     };

    //     fetchUserData();
    // }, []);


    // useEffect(() => {
    //     // Ensure user_id is not undefined, null, or any falsy value before calling getfittingdata
    //     if (user_id) {
    //         getfittingdata();
    //     }
    // }, [user_id]);

    // const getfittingdata = () => {
    //     const data = {
    //         user_id: user_id
    //     };
    //     getremotefittingdatabyfitter(data).then((response) => {
    //         if (!response.data.status) {
    //             alert(response.data.message);
    //         } else {
    //             const data = response.data.data;
    //             setRemotefitting(data);
    //         }
    //     }).catch((err) => {
    //         console.log(err);
    //     });
    // };

    // const buttoncode = () => {
    //     let button;
    //     if (userdata && userdata.user.role_id === 1) {
    //         console.log("fillter");
    //         if (remotefitting && remotefitting.opencloseStatus === 'open') {
    //             button = (
                   
    //             );
    //         } else {
    //             button = (
    //                 <Link to="/pay-now"> {/* Assuming '/pay-now' is the correct path */}
    //                     <button className="btn btn-colr">Pay now</button>
    //                 </Link>
    //             );
    //         }
    //     } else {
    //         console.log("users");
    //         button = (
    //             <Link to="/list-fitting">
    //                 <button className="btn btn-colr">Create new iron fitting</button>
    //             </Link>
    //         );
    //     }

    //     return button;
    // }

    return (
        <div>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="box-content">
                                                <div className="box-title">
                                                    <h3>Iron Fitting</h3>
                                                </div>
                                                <div className="content-box-btn">
                                                    <Link to="/list-fitting">
                                                        <button className="btn btn-colr">Create new iron fitting</button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="box-content">
                                                <div className="box-title">
                                                    <h3>Wedge Fitting</h3>
                                                </div>
                                                <div className="content-box-btn">
                                                    <button className="btn btn-coming-soon">Coming soon</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="box-content">
                                                <div className="box-title">
                                                    <h3>Driver Fitting</h3>
                                                </div>
                                                <div className="content-box-btn">
                                                    <button className="btn btn-coming-soon">Coming soon</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default Fitting;